<template>
    <transition  >
    <div class="container-fluid card-body   ">
        <div class="row">
            <div class="col-12">
                <div class="page-title-box">
                    <div class="page-title-right float-left">
                        <ol class="breadcrumb m-0"> 
                            <li class="breadcrumb-item active">Unit </li>
                            <li class="breadcrumb-item"><a href="javascript: void(0);">Unit Conversion List</a></li>
                            
                        </ol>
                    </div>
                    <div class="page-title-right float-right "> 
                        <button type="button" class="btn btn-primary float-right" @click="toggleModal()">
                            Add New
                        </button> 
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Modal -->
        <Modal @close="toggleModal()" :modalActive="modalActive">
            <div class="modal-content scrollbar-width-thin">
                <div class="modal-header"> 
                    <h3>Unit Conversion Add Or Edit</h3>
                    <button @click="toggleModal()" type="button" class="btn btn-default">X</button>
                </div>
                <form @submit.prevent="submitForm()" enctype="multipart/form-data" >
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">

                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label for="unit_id">Base Unit </label>
                                        <Multiselect 
                                            class="form-control border" 
                                            mode="single"
                                            v-model="form.unit_id"
                                            placeholder="Select Base Unit"  
                                            @change="onChangeUnit($event)"
                                            :searchable="true" 
                                            :filter-results="true"
                                            :options="unit_options"
                                            :classes="multiclasses"
                                            :close-on-select="true" 
                                            :min-chars="1"
                                            :resolve-on-load="false" 
                                            :create-option="true" 
                                        />  
                                        <div class="invalid-feedback" v-if="errors.unit_id">
                                            {{errors.unit_id[0]}}
                                        </div>
                                    </div>
                                </div>
                                <hr>

                                <div class="row" v-if="form.conversion_units.length > 0">
                                    <div class="form-group col-md-6" v-for="(unit, i) in form.conversion_units" :key="i">
                                        <label for="operation_value">{{ unit.conversion_unit_name +' '+'('+unit.conversion_unit_code+')' }} </label>
                                        <input type="text" class="form-control border " @keypress="onkeyPress('conversion_rate')" v-model="unit.conversion_rate" id="conversion_rate" placeholder="Conversion Rate" autocomplete="off"> 
                                        <div class="invalid-feedback" v-if="errors.conversion_rate">
                                            {{errors.conversion_rate[0]}}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-primary " :disabled="disabled">
                            <span v-show="isSubmit">
                                <i class="fas fa-spinner fa-spin" ></i>
                            </span> Submit
                        </button>
                    </div>
                </form>
            </div>
        </Modal>

        <div class="row">
            <div class="col-md-12 ">
                <div class="card">
                    <div class="card-body table-responsive">   
                        <table id="basic-datatable" class="table table-bordered table-centered table-nowrap w-100"  v-if="!loading">
                            <thead class="table-light">
                                <tr class="border success item-head">
                                    <th width="15%" rowspan="2">Unit Name </th>
                                    <th width="15%" rowspan="2">Unit Code </th>
                                    <th colspan="3" style="text-align: center;">Conversion Units</th>
                                    <th rowspan="2" width="15%" style="text-align: center">Actions</th>
                                </tr>
                                <tr>
                                    <th>Unit Name</th>
                                    <th>Unit Code</th>
                                    <th>Coversion Rate</th>
                                </tr>
                            </thead>
                            <tbody v-for="(item, i) in items" :key="i">
                                <tr v-for="(unit, j) in item.unit_matrixes" :key="j" v-if="item.unit_matrixes.length > 0" class="border">
                                    <td v-if="j==0" :rowspan="item.unit_matrixes.length">{{ item.unit_name }} </td>
                                    <td v-if="j==0" :rowspan="item.unit_matrixes.length" style="text-align: center">{{ item.unit_code}} </td>
                                    <td style="color: #02e48d;">{{ unit.conversion_units.unit_name }} </td>
                                    <td style="text-align: center; color: #02e48d">{{ unit.conversion_units.unit_code }} </td>
                                    <td style="text-align: right; color: #02e48d">{{ unit.conversion_rate }} </td>
                                    <td v-if="j==0" :rowspan="item.unit_matrixes.length" style="text-align: center">
                                        <a href="#" @click="edit(item)"><i class="fas fa-edit"></i> </a>
                                        <a href="#" @click="deleteItem(item)"><i class="fas fa-trash"></i> </a>
                                    </td>
                                </tr>
                                <tr v-else>
                                    <td>{{ item.unit_name }} </td>
                                    <td style="text-align: center">{{ item.unit_code}} </td>
                                    <td colspan="3" style="text-align: center"> No Conversion unit for this unit! </td>
                                    <td style="text-align: center">
                                        <a href="#" @click="edit(item)"><i class="fas fa-edit"></i> </a>
                                        <a href="#" @click="deleteItem(item)"><i class="fas fa-trash"></i> </a>
                                    </td>
                                </tr>
                            </tbody>
                            <!-- <tbody v-if="items.length > 0">
                                <tr class="border" >
                                    <td>{{ item.unit_name }} </td>
                                    <td>{{ item.unit_code}} </td>
                                    <td colspan="3">
                                        <table class="table table-bordered" v-if="item.unit_matrixes.length > 0" width="100%">
                                            <tr >
                                                <td>{{ unit.conversion_units.unit_name }} </td>
                                                <td>{{ unit.conversion_units.unit_code }} </td>
                                                <td>{{ unit.conversion_rate }} </td>
                                            </tr>
                                        </table>
                                        <span v-else>No Conversion unit for this unit!</span>
                                    </td>
                                    <td>
                                        <a href="#" @click="edit(item)"><i class="fas fa-edit"></i> </a>
                                        <a href="#" @click="deleteItem(item)"><i class="fas fa-trash"></i> </a>
                                    </td>
                                </tr>
                            </tbody> -->
                        </table>

                        <div class="tab-pane show active" v-if="loading">
                            <div class="row"> 
                                <div class="col-md-5">  
                                </div>
                                <div class=" col-md-2"> 
                                    <img src="../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                </div>
                                <div class="col-md-5">  
                                </div>
                            </div>
                        </div>

                    </div> 
                </div>
            </div>
        </div>
    </div>
    </transition>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import Modal from "../helper/Modal.vue";
import { ref, onMounted } from "vue";
import Form from "vform";
import axios from "axios";
export default {
    name: "Unit",
    components: {
        Modal
    },
    data() {
        return {
            loading: true,
            isSubmit: false,
            showModal: false,
            editMode:false,
            disabled: false,
            modalActive:false,
            errors: {},
            btn:'Create',
            items: [],
            unit_options: [],
            form: new Form({
                id: '',
                unit_id: '',
                conversion_units: [],
            }),
            multiclasses: { 
              clear: '',
              clearIcon: '', 
            }, 
        }
    },
    created() {
        this.fetchUnitData();
    },

    methods: {
        forceRender() {
            this.showModal = false;
            this.$nextTick(() => {
                this.showModal = true;
            });
        },
        toggleModal: function() {
            this.forceRender();
            this.modalActive = !this.modalActive;  
            console.log('this.modalActive', this.modalActive)
            if(!this.modalActive){
                this.editMode = false;
                this.btn='Create';
            } 
            this.errors = '';
            this.isSubmit = false;
            this.form.reset(); 
        },
        fetchUnitData() { 
            axios.get(this.apiUrl+'/unit_conversions', this.headers)
            .then((res) => {
                this.items = res.data.data;
                this.unit_options = res.data.data.map((item) => {
                    return { value: item.id, label: item.unit_name }
                });
                
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            })
            .finally((fres) => {
                this.loading = false;
            });
        },

        onChangeUnit: function(event) {
            let mapUnits = this.items.map((item) => {
                return {
                        conversion_unit_id: item.id,
                        conversion_unit_name: item.unit_name,
                        conversion_unit_code: item.unit_code,
                        conversion_rate: 0,
                    }
            });

            const targetIndex = mapUnits.findIndex(unit => unit.conversion_unit_id === event);
            if (targetIndex !== -1) {
                // Remove the target unit from its current position
                // const [targetUnit] = mapUnits.splice(targetIndex, 1);
                // Add the target unit to the start of the array
                mapUnits.splice(targetIndex, 1);
                // mapUnits.unshift(targetUnit);
                this.form.conversion_units = mapUnits.map(unit => {
                                                    return new Proxy(unit, {
                                                    get(target, property) {
                                                        return target[property];
                                                    },
                                                    set(target, property, value) {
                                                        target[property] = value;
                                                        return true;
                                                    }
                                                    });
                                                });
            }else{
                this.form.conversion_units = mapUnits.map(unit => {
                                                    return new Proxy(unit, {
                                                    get(target, property) {
                                                        return target[property];
                                                    },
                                                    set(target, property, value) {
                                                        target[property] = value;
                                                        return true;
                                                    }
                                                    });
                                                });
            }


        },

        edit: function(item) {
            this.btn='Update';
            this.editMode = true;
            this.toggleModal();
            this.form.fill(item); 
        },
        submitForm: function(e) { 
            
            this.isSubmit = true;
            this.disabled = true;
            const formData = new FormData();  
            formData.append('unit_id', this.form.unit_id);
            formData.append('conversion_units', JSON.stringify(this.form.conversion_units));
            if(this.editMode){
                formData.append('_method', 'put');
                var postEvent = axios.post(this.apiUrl+'/unit_conversions/'+this.form.id, formData, this.headers);
            }else{
                var postEvent = axios.post(this.apiUrl+'/unit_conversions', formData, this.headers);
            }           

            postEvent.then(res => {
                
                this.isSubmit = false;
                this.disabled = false;
                if(res.status == 200){
                    this.toggleModal();
                    this.fetchUnitData();
                    this.$toast.success(res.data.message); 
                }else{
                    this.$toast.error(res.data.message);
                }
            }).catch(err => {  
                this.isSubmit = false;
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                }
            })
        },

        onkeyPress: function(field) { 
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },
        deleteItem: function(item) {
            console.log('item delete=>',item.id);
            this.$swal({
                title: 'Are you sure?',
                text: "You want delete this item!", 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => { 
                if (result.value) { 
                    axios.delete(this.apiUrl+'/units/'+item.id, this.headerjson)
                    .then(res => {
                        if(res.status == 200){ 
                            this.fetchUnitData();
                            this.$toast.success(res.data.message); 
                        }else{
                            this.$toast.error(res.data.message);
                        }
                    }).catch(err => {  
                        this.$toast.error(err.response.data.message);
                        if(err.response.status == 422){
                            this.errors = err.response.data.errors 
                        }
                    }) 
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            }); 
        },
    },
    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {
        permission() {
            let pname = this.$route.meta.parent_module;
            let module_name = this.$route.meta.module_name;
            let path_name = this.$route.path; 
            let data = '';
            if(this.$route.meta.parent_module){
                data = this.$store.getters.userAllPermissions[pname][0].children[path_name]
            }else{
                data = this.$store.getters.userAllPermissions[module_name][0].other_actions; 
            } 
            return data;
        },
    }
}
</script>

<style scoped>
.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 800px;
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}
</style>